import { createAction } from 'redux-actions'
import { RootState } from '../reducers'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { url, post } from '../../assets/javascripts/http'
import { message } from 'antd'
import { ExaminationService } from "../adapters"

let examinationService = new ExaminationService(url, post);


export function actionSaveDetectorInfo(data: any) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        try {

            message.loading('保存中...', 0)
            data.client = 'posture_detection_app'
            await examinationService.addExamineeByAccountId(data)
            dispatch(actionSaveDetectorInfoSuccess({
                saveStatus: true
            }))
            message.destroy();
        } catch(error) {
            message.destroy();
            console.log(error)
        }
    }
}

export const ACTION_SAVEDETECTORINFO_SUCCESS = 'USER.ACTION_SAVEDETECTORINFO_SUCCESS';

export interface ActionSaveDetectorInfoPayload {
    saveStatus: any
}

export const actionSaveDetectorInfoSuccess = createAction(
    ACTION_SAVEDETECTORINFO_SUCCESS,
    (payload: ActionSaveDetectorInfoPayload) => {
        return payload;
    }
)